
//Автоматическая установка высоты блока новостей

if (document.querySelector('.home-news') || document.querySelector('.news-wrapper')) {
    function adjustTextBlockHeight() {
        const textBlocks = document.querySelectorAll('.home-news-block-text');
        const isNewsWrapper = document.querySelector('.news-wrapper');

        textBlocks.forEach(block => {
            const title = block.querySelector('.home-news-text-item__name');
            const text = block.querySelector('.home-news-block-item__text');

            // Получаем реальную высоту заголовка
            const titleHeight = title.offsetHeight;

            // Вычисляем доступную высоту для текста
            const blockHeight = isNewsWrapper ? 190 : 225; // Общая высота блока
            const marginBottom = 8; // Отступ между заголовком и текстом
            const availableHeight = blockHeight - titleHeight - marginBottom;

            // Вычисляем количество строк, которые поместятся
            const lineHeight = parseFloat(getComputedStyle(text).lineHeight);
            const possibleLines = Math.floor(availableHeight / lineHeight);

            // Устанавливаем количество строк
            text.style.webkitLineClamp = possibleLines.toString();
            text.style.maxHeight = `${possibleLines * lineHeight}px`;
        });
    }

    // Выполняем при загрузке страницы
    document.addEventListener('DOMContentLoaded', adjustTextBlockHeight);

    // Выполняем при изменении размера окна
    window.addEventListener('resize', adjustTextBlockHeight);


    if (document.getElementById('newsBlock')) {
        document.addEventListener('DOMContentLoaded', function() {
            function adjustHeight() {
                const newsBlock = document.getElementById('newsBlock');
                const wrapper = newsBlock.querySelector('.home-news-block-wrapper');
                const sideColumns = document.querySelectorAll('.app-col-lg-3');
                const textList = document.querySelector('.home-news-text-list');

                if (window.innerWidth >= 992) {
                    const height = wrapper.offsetHeight;
                    newsBlock.style.height = height + 'px';

                    sideColumns.forEach(column => {
                        column.style.height = height + 'px';
                    });

                    textList.style.maxHeight = height + 'px';
                } else {
                    newsBlock.style.height = 'auto';

                    sideColumns.forEach(column => {
                        column.style.height = 'auto';
                    });

                    textList.style.maxHeight = 'none';
                }
            }

            // Вызываем функцию при загрузке и изменении размера окна
            adjustHeight();
            window.addEventListener('resize', adjustHeight);
        });
    }

}
